import { useDispatch } from 'react-redux';
import { formatMoneyKr } from '../../../utils';
import { getFormActions } from '../../../utils/form-helpers';
import formConfig from '../../../payment/payment-form-config';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import styles from './suggested-amount.module.less';
import { Chip } from '@sb1/ffe-chips-react';
import { useProject } from '../../project-hooks/useProject';
import { Label } from '@sb1/ffe-form-react';
import { SUGGESTED_AMOUNTS_TEXT_KEY } from '../../i18n/project-i18n-model';
import { useI18nTexts } from '../../i18n/useI18nTexts';

const { setFormField } = getFormActions(formConfig);

const AmountChip = ({ amount, setAmount, size = 'sm' }) => (
    <Chip
        as="button"
        size={size}
        onClick={() => setAmount(amount)}
        aria-label={`Sett beløp til ${formatMoneyKr(amount)}`}
    >
        {formatMoneyKr(amount)}
    </Chip>
);

const SuggestedAmounts = ({ onAmountChange, trackingCategory, amounts = [250, 550, 1200, 2000] }) => {
    const project = useProject();
    const dispatch = useDispatch();
    const texts = useI18nTexts([SUGGESTED_AMOUNTS_TEXT_KEY]);
    const modeTransactionAmount = project?.transactionStats?.mode_transaction_amount;

    const setAmount = (amount) => {
        trackEvent(trackingCategory, 'checkout-suggestion', {
            amount,
            'project-id': project?.id,
            mode: modeTransactionAmount || 'none',
        });
        dispatch(setFormField('amount', amount));
        if (onAmountChange) {
            onAmountChange(amount);
        }
    };

    return (
        <div>
            <Label className={styles.chipLabel}>{texts[SUGGESTED_AMOUNTS_TEXT_KEY]}</Label>
            <fieldset className={styles.fieldset} aria-labelledby="suggested-amounts">
                <div className={styles.chipContainer}>
                    {amounts.map((amount) => (
                        <AmountChip
                            key={amount}
                            amount={amount}
                            setAmount={setAmount}
                            size={amounts.length < 4 ? 'md' : 'sm'}
                        />
                    ))}
                </div>
            </fieldset>
        </div>
    );
};

export default SuggestedAmounts;
